[
  {
    "id": 1,
    "name": "teaspoon",
    "abbr": "tbsp",
    "type": "volume",
    "ratio": 48
  },
  {
    "id": 2,
    "name": "tablespoon",
    "abbr": "tsp",
    "type": "volume",
    "ratio": 16
  },
  {
    "id": 3,
    "name": "cup",
    "abbr": "cup",
    "type": "volume",
    "ratio": 1
  },
  {
    "id": 4,
    "name": "ounce",
    "abbr": "oz",
    "type": "weight",
    "ratio": 28
  }
]
